import React from "react";
import PopupLoader from "../SMCaseLoadPopup/SmcasePopupLoader";
import EditTransactionPopup from "@frameworks/web/components/Reports/PNLReports/PnlEditScreen/EditTransactionPopup";
import ConfirmationPopup from "@frameworks/web/components/generic/ConfirmationPopup/ConfirmationPopup";
import SmcasePopupSuccess from "@frameworks/web/components/Reports/HoldingReports/SMCaseLoadPopup/SmcasePopupSuccess";
import SmcasePopupFail from "@frameworks/web/components/Reports/HoldingReports/SMCaseLoadPopup/SmcasePopupFail";
import { getDay } from "@domains/utils/reportDates";
import { useSelector } from "react-redux";
import { accountDetails } from "@di";
import moment from "moment";
import DeviceContext from "@frameworks/web/utils/indentifyDevice";
import PNLDI from "@frameworks/web/components/Reports/PNLReports/di/servicelocator";
import _ from "underscore";
const EditTxnsFromSideBar = ({ editableRecord, showEditablePopup, setShowEditablePopup, summaryParamters, }) => {
    const { txnStatus: txnStatusError, editTXNShimmer: editTXNShimmer, pnlOriginalTxns: pnlOriginalTxns, orgTxnLoader: orgTxnLoader, orgTxnStatus: orgTxnStatus, } = useSelector((state) => state.pnltranasactionReport);
    const AccountDetails = useSelector((state) => state.accountDetailsReducer);
    const [reviewChangePopup, setReviewChangePopup] = React.useState(false);
    const [editPNLTransactionFail, setEditPNLTransactionFail] = React.useState(false);
    const [editPNLTransactionSuccess, setEditPNLTransactionSuccess] = React.useState(false);
    const [editPNLTransactionAPICall, seteditPNLTransactionAPICall] = React.useState(false);
    const [pnLEditSplitRequests, setPnLEditSplitRequests] = React.useState([]);
    const editConfirmation = () => {
        setShowEditablePopup(false);
        setReviewChangePopup(true);
    };
    const reviewGoBack = () => {
        setReviewChangePopup(false);
        setShowEditablePopup(true);
    };
    const sendSplitRecord = async () => {
        if (summaryParamters) {
            let tempData = pnLEditSplitRequests;
            if (pnLEditSplitRequests && pnLEditSplitRequests.length > 0) {
                tempData = pnLEditSplitRequests.map((editRecord) => {
                    editRecord.newDate =
                        moment(editRecord.newDate).format("yyyy-MM-DD") == "Invalid date"
                            ? moment(editRecord.newDate, "DD-MM-YY").format("yyyy-MM-DD")
                            : moment(editRecord.newDate).format("yyyy-MM-DD");
                    return editRecord;
                });
            }
            const payload = {
                accountId: await accountDetails.getAccountCode(),
                fromDate: moment(summaryParamters.fromDate).format("yyyy-MM-DD"),
                toDate: moment(summaryParamters.toDate).format("yyyy-MM-DD"),
                transactionType: summaryParamters.transactionType,
                scripIdentifier: editableRecord === null || editableRecord === void 0 ? void 0 : editableRecord.scripIdentifier,
                pnLEditSplitRequests: tempData,
            };
            PNLDI.pnlTransactionReport.sendEditSplitPNLTransactionData(payload);
            seteditPNLTransactionAPICall(true);
        }
    };
    const reviewConfirm = () => {
        setReviewChangePopup(false);
        sendSplitRecord();
    };
    React.useEffect(() => {
        if (editPNLTransactionAPICall &&
            txnStatusError &&
            txnStatusError.isOpen !== null &&
            DeviceContext().isDesktop) {
            if (txnStatusError.isOpen)
                setEditPNLTransactionSuccess(true);
            else
                setEditPNLTransactionFail(true);
        }
    }, [txnStatusError, editPNLTransactionAPICall]);
    return (React.createElement("div", null,
        (reviewChangePopup || showEditablePopup) && (React.createElement(React.Fragment, null,
            !orgTxnLoader && !orgTxnStatus.isOpen && (React.createElement(EditTransactionPopup, { show: showEditablePopup, popTitle: "Edit Transaction", setShow: setShowEditablePopup, popupClass: "", ConfirmBtnTitle: "Confirm", description: "", goBackBtn: false, confirmBtnCta: editConfirmation, goBackCta: () => setShowEditablePopup(false), editableRecord: editableRecord, summaryParamters: summaryParamters, setPnLEditSplitRequests: setPnLEditSplitRequests })),
            React.createElement(ConfirmationPopup, { popupClass: "", description: `You are not allowed to edit the details more than once. 
                Are you sure you want to continue?`, popTitle: "Confirm Editing", show: reviewChangePopup, setShow: setReviewChangePopup, btnFirstTitle: "Review Changes", btnSecTitle: "Yes, Confirm", goBackBtn: false, btnFirstCta: reviewGoBack, btnSecCta: reviewConfirm, showFooter: true }))),
        (editTXNShimmer || orgTxnLoader) && (React.createElement("div", { className: "modalBackground" },
            React.createElement("div", { className: "modalContainer" },
                React.createElement(PopupLoader, { Title: "Transaction", message: `` })))),
        editPNLTransactionSuccess && (React.createElement("div", { className: "modalBackground" },
            React.createElement("div", { className: "modalContainer" },
                React.createElement(SmcasePopupSuccess, { setDownloadSuccess: setEditPNLTransactionSuccess, isDownload: false, Title: "Edit PNL Transaction", operation: null, pageName: "Holding Report", tabName: "", message: "Your request was successfully processed.<br/>" +
                        "Updated price will reflect in the P&L on " +
                        moment(getDay(1)).format("DD-MM-yyyy") +
                        ".", sendBack: true, goBack: () => {
                        document.body.classList.add("flow-overlay");
                        setEditPNLTransactionSuccess(false);
                    } })))),
        (editPNLTransactionFail || orgTxnStatus.isOpen) && (React.createElement("div", { className: "modalBackground" },
            React.createElement("div", { className: "modalContainer" },
                React.createElement(SmcasePopupFail, { isDownload: false, setDownloadFail: setEditPNLTransactionFail, Title: "Edit PNL Transaction ", operation: null, pageName: "Holding Report", sendBack: true, goBack: () => {
                        document.body.classList.add("flow-overlay");
                        setEditPNLTransactionFail(false);
                    } }))))));
};
export default React.memo(EditTxnsFromSideBar, (prevProps, nextProps) => _.isEqual(prevProps, nextProps));
